"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = GlobeGrid;

var _GlobeGrid = require("@adobe/react-spectrum-workflow/dist/GlobeGrid");

var _icon = require("@react-spectrum/icon");

var _react = _interopRequireDefault(require("react"));

function GlobeGrid(props) {
  return /*#__PURE__*/_react.default.createElement(_icon.Icon, props, /*#__PURE__*/_react.default.createElement(_GlobeGrid.A4uGlobeGrid, null));
}